import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdicionaisEDescontosEditarRoutingModule } from './adicionais-e-descontos-editar-routing.module';
import { AdicionaisEDescontosEditarComponent } from './adicionais-e-descontos-editar.component';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    AdicionaisEDescontosEditarComponent
  ],
  imports: [
    CommonModule,
    AdicionaisEDescontosEditarRoutingModule,
    FormsModule,
    InputTextModule,
    DropdownModule,
    DividerModule,
    MessagesModule,
    CalendarModule,
    InputNumberModule,
    ProgressSpinnerModule
  ]
})
export class AdicionaisEDescontosEditarModule { }
